<div class="container text-center">
  @if (selectedDealerInformation) {
    {{ "DEALER_SELECTED" | translate }}:
    {{ selectedDealerInformation.name }} ({{
    selectedDealerInformation.dealer_code
    }})
  }
  <span
    class="custom-btn clickable withOpacity bg-success text-white px-2"
    (click)="selectDealer()"
    >{{ (selectedDealer ? "CHANGE" : "SELECT_DEALER") | translate }}</span
    >
  </div>
